import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import classnames from "classnames";

import JewelInfoStyles from "components/menu/JewelInfo.module.scss";

import { GlamboxBadge } from "core/glambox/GlamboxBadge";

//import IconPearl from "assets/img/jewel/pearl.png";
//import IconEmerald from "assets/img/jewel/emerald.png";
//import IconRuby from "assets/img/jewel/ruby.png";
//import IconSapphire from "assets/img/jewel/sapphire.png";
//import IconDiamond from "assets/img/jewel/diamond.png";

import { Pearl } from "components/badges/Pearl";
import { Emerald } from "components/badges/Emerald";
import { Ruby } from "components/badges/Ruby";
import { Sapphire } from "components/badges/Sapphire";
import { Diamond } from "components/badges/Diamond";
import { UiActions } from "state/actions/UiActions";

class JewelInfo extends Component {
  constructor (props) {
    super(props);

    this.setBadgeClass = this.setBadgeClass.bind(this);
    this.setBadgeIcon = this.setBadgeIcon.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }

  closeMenu () {
    this.props.menuHide();
  }

  setBadgeClass () {
    let badgeClass = null,
        badge = this.props.person.data.badge;

    if (badge !== undefined && badge !== null && badge.badgeId) {
      badgeClass = GlamboxBadge.getJewelSlug(
        badge.badgeId
      );
    }

    return badgeClass;
  }

  setBadgeIcon () {
    let badge = this.props.person.data.badge;
    
    switch (badge.badgeId) {
      case 1:
        return <Pearl />;        
      case 2:
        return <Emerald />;        
      case 3:
        return <Ruby />;        
      case 4:
        return <Sapphire />;
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
        return <Diamond />;
      default:
        return null;
    }
  }

  render () {
    if (!this.props.person.data.badge) return null;

    let _cls = [
      JewelInfoStyles["jewel-info"]
    ];

    if (this.setBadgeClass() !== null) {
      _cls.push(JewelInfoStyles[this.setBadgeClass()]);
    }

    let { data } = this.props.person;

    return (
      <div className={classnames(_cls)}>
        <div className={JewelInfoStyles["jewel-info__icon"]}>
          {this.setBadgeIcon()}
        </div>
        <div className={JewelInfoStyles["jewel-info__data"]}>
          <p>Joia: <strong>{data.badge.title}</strong></p>
          <p>Saldo: <strong>{data.person.rewardBalance} Glampoints</strong></p>
        </div>
        <NavLink onClick={this.closeMenu} to={"/glampoints"} className={classnames(JewelInfoStyles["jewel-info__link"], JewelInfoStyles[this.setBadgeClass()])}>
          <svg className={classnames(JewelInfoStyles["jewel-info__link-icon"], JewelInfoStyles[this.setBadgeClass()])} width="24.259" height="40" viewBox="0 0 24.259 40">
            <path d="M14.011,40a4.956,4.956,0,0,1-3.592-8.372L21.508,19.965,10.43,8.383a4.957,4.957,0,0,1,7.164-6.853l14.346,15a4.96,4.96,0,0,1,.011,6.842L17.606,38.459A4.953,4.953,0,0,1,14.011,40Z" transform="translate(-9.055 0)"></path>
          </svg>
        </NavLink>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  person: state.person,
  ui: state.ui
});

const mapDispatchToProps = (dispatch) => ({
  menuHide: () => {
    dispatch(UiActions.menuHide())
  }
});

JewelInfo = connect(
  mapStateToProps,
  mapDispatchToProps
)(JewelInfo);

export {
  JewelInfo
};
